<template>
  <f7-page loginScreen>
    <f7-login-screen-title>
      <div>使用者登入</div>
      <div style="font-size: 18px;">{{ fullStoreName }}</div>
    </f7-login-screen-title>

    <f7-block id="auth-block">
      <f7-toolbar tabbar style="background-color: white; color: #000000;">
        <f7-link tab-link="#tab-1" tab-link-active>登入</f7-link>
        <f7-link tab-link="#tab-2">註冊新帳號</f7-link>
      </f7-toolbar>
      <f7-tabs>
        <f7-tab id="tab-1" tab-active>
          <f7-list form>
            <f7-list-item>
              <f7-label>
                帳號
                <span v-if="this.email.length !== 0 && !isEmailValid" style="color: red;">(Email 格式不正確)</span>
              </f7-label>
              <f7-input type="text" placeholder="請輸入 Email 或 手機" :value="email" @input="email = $event.target.value"></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-label>密碼</f7-label>
              <f7-input type="password" placeholder="請輸入密碼" @input="password = $event.target.value"></f7-input>
            </f7-list-item>
          </f7-list>
          <f7-list>
            <f7-button fill raised class="submit-button" :style="{ background: isEmailValid && password.length !== 0 ? '#4CAF50' : '#AAAAAA' }" @click="signInWithEmailAndPasswordOnClick">
              登入
            </f7-button>
          </f7-list>
          <f7-block-title>或是其他登入方式:</f7-block-title>
          <f7-list>
            <f7-list-item>
              <f7-list-item-cell>
                <f7-button raised fill style="margin: 0px auto; width: 200px;" @click="signInWithGoogle">
                  Google
                </f7-button>
              </f7-list-item-cell>
            </f7-list-item>
          </f7-list>
        </f7-tab>
        <f7-tab id="tab-2">
          <f7-list form>
            <f7-list-item>
              <f7-label>
                帳號
                <span v-if="this.email.length !== 0 && !isEmailValid" style="color: red;">(Email 格式不正確)</span>
              </f7-label>
              <f7-input type="text" placeholder="請輸入 Email" :value="email" @input="email = $event.target.value"></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-label>密碼</f7-label>
              <f7-input type="password" placeholder="請輸入密碼" :value="password" @input="password = $event.target.value"></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-label>
                請再次輸入密碼
                <span v-if="password !== newPassword" style="color: red;">(密碼不相同)</span>
              </f7-label>
              <f7-input type="password" placeholder="請再次輸入密碼" @input="newPassword = $event.target.value"></f7-input>
            </f7-list-item>
          </f7-list>
          <f7-list>
            <f7-button class="submit-button" fill raised :style="{ background: isEmailValid && password === newPassword ? '#4CAF50' : '#AAAAAA' }" @click="createUserOnClick">
              註冊
            </f7-button>
          </f7-list>
          <f7-block-title>或是以其他登入方式註冊:</f7-block-title>
        </f7-tab>
      </f7-tabs>
    </f7-block>
  </f7-page>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  dependencies: ['platformUtils', 'themeColor', 'userSignInStatusType'],
  data () {
    return {
      email: '',
      password: '',
      newPassword: ''
    }
  },
  watch: {
    signInStatus (status) {
      const url = this.getQueryString('r')
      if (status === this.userSignInStatusType.processing) {
        // return
      } else if (status === this.userSignInStatusType.signedIn) {
        if (url) {
          this.$f7router.navigate(url, {
            reloadCurrent: true
          })
        } else {
          this.$f7router.navigate('/', {
            reloadCurrent: true
          })
        }
        this.$f7.notification.create({
          title: 'EZMeals',
          titleRightText: this.fullStoreName,
          text: '登入成功',
          closeOnClick: true,
          closeButton: true,
          closeTimeout: 2000
        }).open()
      } else {
        this.$f7router.navigate(`/auth${url ? `?r=${url}` : ''}`, {
          reloadCurrent: true
        })
      }
    }
  },
  computed: {
    ...mapState('userModule', ['uid', 'signInStatus']),
    ...mapGetters(['storeId', 'fullStoreName']),
    isEmailValid () {
      return emailRegex.test(this.email)
    }
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('userModule', [
      'signInWithGoogle',
      'signInWithEmailAndPassword',
      'createUser',
      'signOut'
    ]),
    signInWithEmailAndPasswordOnClick () {
      // this.$f7.dialog.progress('登入中，請稍後...')
      if (this.isEmailValid && this.password.length !== 0) {
        this.signInWithEmailAndPassword({
          email: this.email,
          password: this.password
        })
      } else {
        alert('請輸入相同密碼')
      }
    },
    createUserOnClick () {
      if (this.isEmailValid && this.password === this.newPassword) {
        this.createUser({
          email: this.email,
          password: this.password
        })
      } else {
        alert('請輸入相同密碼')
      }
    },
    getQueryString (name) {
      const url = window.location.href
      name = name.replace(/[[\]]/g, '\\$&')
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      const results = regex.exec(url)
      if (!results) {
        return null
      }
      if (!results[2]) {
        return ''
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }
  }
}

</script>

<style lang="scss">
#auth-block div.toolbar.tabbar div.toolbar-inner a.tab-link {
  color: black;
}

#auth-block div.toolbar.tabbar div.toolbar-inner span.tab-link-highlight {
  background: #4CAF50;
}

</style>

<style lang="scss" scoped>
.submit-button {
  margin: 10px;
}

#auth-block {
  border-radius: 10px;
  border: solid 1px #DDDDDD;
  padding: 0px;
  margin: 10px;
  overflow: hidden;
}

</style>
